import { useSuspenseQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import {
  GET_ORGANIZATION_SUMMARY_PATH,
  GetOrganizationSummaryErrorDto,
  GetOrganizationSummarySuccessDto,
} from '@/api/rest/resources/types/organization';
import { useOrganizationId } from '@/pages/shared/hooks/useOrganizationId';
import { assertIsDefined } from '@/utils/assert';

type SuccessDto = GetOrganizationSummarySuccessDto;
type ErrorDto = GetOrganizationSummaryErrorDto;

export const useOrganizationSummary = (organizationIdArg?: string) => {
  const orgId = useOrganizationId();
  const organizationId = organizationIdArg ?? orgId;
  assertIsDefined(organizationId, 'organizationId');

  const pathParams = { organization_id: organizationId };

  const queryFn = async () => {
    return getRequest<SuccessDto>(GET_ORGANIZATION_SUMMARY_PATH, pathParams);
  };

  return useSuspenseQuery<SuccessDto, ErrorDto>({
    queryKey: ['organization', pathParams, 'summary'],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};
